import React from 'react';
import { Grid, Menu, Icon } from 'semantic-ui-react';

import AdmArea from './AdmArea';

class AdminContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      adminArea: 'channels'
    }
  }

  render() {
    return (
        <Grid>
          <Grid.Row color='blue' centered>
            <Menu compact inverted icon='labeled'>

              {/* The area term must match the endpoint data of the AdminArea component.
                Otherwise: Wrong type beef. // TODO: fix with react router and params via context */}

              <Menu.Item onClick={() => this.setState({adminArea: 'channels'})}>
                <Icon name='desktop' />
                Channels
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'actions'})}>
                <Icon name='idea' />
                Actions
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'requirements'})}>
                <Icon name='list ol' />
                Requirements
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'howtos'})}>
                <Icon name='comments' />
                How-Tos
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'reqtypes'})}>
                <Icon name='hashtag' />
                Requirement Types
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'tags'})}>
                <Icon name='tag' />
                Tags
              </Menu.Item>
              <Menu.Item onClick={() => this.setState({adminArea: 'publisher'})}>
                <Icon color='red' name='flag checkered' />
                Publisher
              </Menu.Item>
            </Menu>
          </Grid.Row>
          <Grid.Row>
            <AdmArea area={this.state.adminArea} />
          </Grid.Row>
        </Grid>
    );
  }

}

export default AdminContainer;



// WEBPACK FOOTER //
// ./src/components/protected/AdminContainer.js